import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import {
  Grid,
} from '@mui/material';
import { useVerifyEmailMutation } from '../../../../graphql/generated/graphql';

import { saveRefreshToken, saveToken } from '../../../helper/auth';
import FormVerifyPage from './form';
import ConfirmVerifyPage from './confirm';
import OnBoardingLayout from '../../../theme/templates/on-boarding';
import { setLoginUser } from '../../../hooks/loginInfo';
import { setAuth } from '../../../hooks/auth';

let initialized = false;

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [verifyMutation] = useVerifyEmailMutation();
  const [confirm, setConfirm] = useState(false);
  const [valid, setValid] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (initialized) return;
    initialized = true;
    async function verifyAction() {
      try {
        const response = await verifyMutation({
          variables: {
            token: params.token || '',
          },
        });
        setConfirm(true)
        setValid(true)
        setEmail(response.data?.verifyEmail.payload.email);
        setLoginUser(response.data?.verifyEmail?.payload);
        saveToken(response.data?.verifyEmail?.token as string);
        saveRefreshToken(response.data?.verifyEmail?.refresh_token as string);
        setTimeout(() => {
          setAuth(true);
          navigate('/');
        }, 5000);
      } catch (e) {
        setValid(true)
        setConfirm(false)
      }
    }
    verifyAction();
  });

  return (
    <>
      { valid && (
      <OnBoardingLayout>
        <Grid
          sx={{
            maxWidth: '90%',
            width: '500px',
            mb: 2,
            mx: 4,
            py: 2,
            px: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          item
        >
          { confirm ? <ConfirmVerifyPage email={email} /> : <FormVerifyPage token={params.token as string} />}
        </Grid>
      </OnBoardingLayout>
      )}
    </>
  )
};

export default VerifyEmailPage;
